import { render, staticRenderFns } from "./StructurePublicChamber.vue?vue&type=template&id=1156550b&scoped=true&"
import script from "./StructurePublicChamber.vue?vue&type=script&lang=js&"
export * from "./StructurePublicChamber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156550b",
  null
  
)

export default component.exports